<mat-card appearance="outlined" style="max-width: 400px; min-width: 280px; margin: 10px; background-color: #303030;" class="mat-elevation-z8">
  <mat-card-header>
    <div mat-card-avatar class="example-header-image">
      <mat-icon>view_list</mat-icon>
    </div>

    <!-- <img mat-card-avatar *ngIf="!(this.Player.ProfileImage)" src="../../assets/img/icons8-user-shield-48.png">     -->
    <mat-card-title>
      <mat-label>
        {{ Workout.Name }}
      </mat-label>
    </mat-card-title>
    <mat-card-subtitle>
      <div style="display: flex; flex-direction: row;">
        <mat-icon style="font-size: 15px; color: gray;">schedule</mat-icon>
        <label style="color: gray">{{ Workout.EstimatedDuration }} min</label>
        <div class="status-card" [style.background-color]="statuscardcolor(Workout.Status)">
          {{ Workout.Status}}
        </div>
      </div>


    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content >
    <table>
      @for (section of Workout.Sections; track section) {
        <tr>
          <td colspan="4">{{section.Name}}</td>
        </tr>
        @for (exercise of section.Exercises; track exercise) {
          <tr>
            <td style="width: 10px;"></td>
            <td class="exercise">
              <mat-icon style="font-size: small;">fitness_center</mat-icon>
              {{ exercise.Name }}
            </td>
            <td style="display: flex;">
              <div class="settemplate">
                @if (exercise.Sets>0) {
                  {{ exercise.Sets}} *
                }
                @if (exercise.Reps>0) {
                  {{ exercise.Reps}} -
                }
                @if (exercise.Effect>0) {
                  {{ exercise.Effect}}W
                }
                @if (exercise.Duration>0) {
                  {{ exercise.Duration}} {{ exercise.DurationUnit}}
                }
                @if (exercise.Weight>0) {
                  {{ exercise.Weight}} kg
                }
              </div>
              @if (exercise.TrainingMethod) {
                <div class="method">
                  {{ exercise.TrainingMethod.Name }}
                </div>
              }
            </td>
            <td></td>
          </tr>
        }
      }

    </table>
  </mat-card-content>


</mat-card>
